import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';

import { ConfigService } from '../../shared/utils/config.service';
import { Credentials } from '../../shared/models/credentials.interface';
import { BaseService } from "./base.service";

import { Observable } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/Rx';

// Add the RxJS Observable operators we need in this app.
import '../../rxjs-operators';
import { map } from 'rxjs/operators';
import { CredentialsChangPassword } from '@shared/models/credentialsChangPassword';

@Injectable()
export class UserService extends BaseService {

    baseUrl: string = "";

    // Observable navItem source
    private _authNavStatusSource = new BehaviorSubject<boolean>(false);
    // Observable navItem stream
    authNavStatus$ = this._authNavStatusSource.asObservable();

    private _profile = new BehaviorSubject<any>(null);
    profile$ = this._profile.asObservable();

    private loggedIn = false;

    constructor(private http: Http, configService: ConfigService) {
        super();
        this.loggedIn = !!localStorage.getItem('auth_token');
        this._authNavStatusSource.next(this.loggedIn);
        this.baseUrl = configService.getApiURI();
    }


    login(credential: Credentials) {

        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let service = this.baseUrl + '/auth/login';

        return this.http
            .post(
                service,
                JSON.stringify({ userName: credential.email, password: credential.password }), { headers }
            )
            .map(res => res.json())
            .pipe(map(res => {
                console.log("res: ", res);
                localStorage.setItem('auth_token', credential.email);
                localStorage.setItem('user_logado', JSON.stringify(res));

                this.loggedIn = true;
                this._authNavStatusSource.next(true);

                return res;
            }));
    }

    reset(credential: Credentials) {

        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        //this.baseUrl + '/auth/login'
        let service = this.baseUrl + '/auth/reset';

        return this.http
            .post(
                service,
                JSON.stringify({ userName: credential.email, password: credential.password }), { headers }
            )
            .map(res => res.json())
            .pipe(map(res => {
                return res;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        //localStorage.removeItem('currentUser');
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_logado');
        this.loggedIn = false;
        this._authNavStatusSource.next(false);
    }

    slogin(credential: Credentials) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        //this.baseUrl + '/auth/login'
        let service = this.baseUrl + '/auth/login';//;

        return this.http
            .post(
                service,
                JSON.stringify({ userName: credential.email, password: credential.password }), { headers }
            )
            .map(res => res.json())
            .map(res => {
                console.log("res: ", res);
                localStorage.setItem('auth_token', res.access_token);

                this.loggedIn = true;
                this._authNavStatusSource.next(true);
            })
            .catch(this.handleError);
    }

    profile(): Observable<any> {
        console.log('get profile');
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let authToken = localStorage.getItem('auth_token');
        headers.append('Authorization', `Bearer ${authToken}`);

        let serviceMock = this.baseUrl + '/profile/current';

        return this.http.get(serviceMock, { headers })
            .map(response => response.json())
            .catch(this.handleError);
    }

    getProfile() {
        this.profile().subscribe(res => {
            this._profile.next(res);
        },
            (err) => console.log(err),
            () => console.log("Done")
        );
    }

    slogout() {
        localStorage.removeItem('auth_token');
        this.loggedIn = false;
        this._authNavStatusSource.next(false);
    }

    isLoggedIn() {
        return this.loggedIn;
    }

    authNavStatus() {
        return this.authNavStatus$;
    }

    getUserLogado(token, token2) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", `Bearer ${token}`);
        headers.append("Authorization2", `Bearer2 ${token2}`);

        return this.http
          .get(`${this.baseUrl}/auth/getUsario`, {headers})
          .map(response => response.json())
          .catch(this.handleError);
    }

    changePassword(credential: CredentialsChangPassword) {

        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        //this.baseUrl + '/auth/login'
        let service = this.baseUrl + '/auth/changePassword';

        return this.http
            .post(
                service,
                JSON.stringify({ emailPassword: credential.emailPassword, newPassword: credential.newPassword, confirmPassword: credential.confirmPassword, email: credential.email }), { headers }
            )
            .map(res => res.json())
            .pipe(map(res => {
                return res;
            }));
    }
}
